<template>
  <v-card class="ma-0 pa-0" variant="text">
    <v-card-text class="ma-0 pa-0">
      <v-stepper
        v-model="stepper"
        alt-labels
        class="bg-transparent elevation-0 ma-0 pa-0 mb-5"
      >
        <v-stepper-header>
          <v-stepper-item
            :value="1"
            :complete="stepOneComplete"
            :error="stepOneError"
          >
          </v-stepper-item>
          <v-divider></v-divider>
          <v-stepper-item
            :value="2"
            :complete="stepTwoComplete"
            :error="stepTwoError"
          >
          </v-stepper-item>
          <v-divider></v-divider>
          <v-stepper-item
            :value="3"
            :complete="stepThreeComplete"
            :error="stepThreeError"
          ></v-stepper-item>
        </v-stepper-header>

        <v-stepper-window>
          <v-stepper-window-item :value="1" :editable="stepOneComplete">
            <v-card variant="text" class="ma-0 pa-0">
              <v-card-title class="text-h5 ma-0 pa-0 text-primary">
                {{ resources.UserData }}
              </v-card-title>
              <v-card-text class="ma-0 pa-0">
                <v-row class="ma-0 pa-0">
                  <v-col cols="12" class="ma-0 pa-0">
                    <p>{{ resources.UserDataDescription }}</p>
                  </v-col>
                </v-row>
                <v-form class="ma-0 pa-0" ref="formStepOne">
                  <v-row class="ma-0 pa-0">
                    <v-col cols="12" md="6" lg="3">
                      <div
                        v-if="preview['profilePicture']"
                        class="mt-2 d-flex justify-center"
                      >
                        <v-img
                          :src="preview['profilePicture']"
                          max-width="200"
                          max-height="200"
                          cover
                          class="rounded-circle elevation-2"
                        />
                      </div>
                    </v-col>
                    <v-col cols="12" md="6" lg="3">
                      <v-file-input
                        accept="image/*"
                        prepend-inner-icon="mdi-image"
                        variant="outlined"
                        density="comfortable"
                        color="primary"
                        :multiple="false"
                        :label="resources.ProfilePicture"
                        :hint="resources.ProfilePictureHelp"
                        persistent-hint
                        :rules="[globalStore.rules.required]"
                        @update:modelValue="
                          onImageChange($event, 'profilePicture')
                        "
                        clearable
                      />
                    </v-col>
                    <v-col cols="12" md="6" lg="3">
                      <v-text-field
                        v-model="model.email"
                        :label="resources.Email"
                        :hint="resources.EmailHelp"
                        persistent-hint
                        :rules="[
                          globalStore.rules.required,
                          globalStore.rules.email,
                        ]"
                        prepend-inner-icon="mdi-email-outline"
                        clearable
                        variant="outlined"
                        density="comfortable"
                        color="primary"
                      />
                    </v-col>
                    <v-col cols="12" md="6" lg="3">
                      <v-text-field
                        v-model="model.password"
                        :label="resources.Password"
                        :hint="resources.PasswordHelp"
                        :type="show ? 'text' : 'password'"
                        :append-inner-icon="
                          show ? 'mdi-eye-off-outline' : 'mdi-eye-outline'
                        "
                        @click:append-inner="toggleShow"
                        persistent-hint
                        :rules="[globalStore.rules.required]"
                        prepend-inner-icon="mdi-form-textbox-password"
                        clearable
                        variant="outlined"
                        density="comfortable"
                        color="primary"
                      />
                    </v-col>
                    <v-col cols="12" md="6" lg="3">
                      <v-text-field
                        v-model="confirmPassword"
                        :label="resources.ConfirmPassword"
                        :hint="resources.ConfirmPasswordHelp"
                        :type="show ? 'text' : 'password'"
                        :append-inner-icon="
                          show ? 'mdi-eye-off-outline' : 'mdi-eye-outline'
                        "
                        @click:append-inner="toggleShow"
                        persistent-hint
                        :rules="[
                          globalStore.rules.required,
                          (v) =>
                            v === model.password ||
                            'Las contraseñas no coinciden',
                        ]"
                        prepend-inner-icon="mdi-form-textbox-password"
                        clearable
                        variant="outlined"
                        density="comfortable"
                        color="primary"
                      />
                    </v-col>
                    <v-col cols="12" md="6" lg="3">
                      <v-text-field
                        v-model="model.name"
                        :label="resources.Name"
                        :hint="resources.NameHelp"
                        persistent-hint
                        :rules="[globalStore.rules.required]"
                        prepend-inner-icon="mdi-form-textbox"
                        clearable
                        variant="outlined"
                        density="comfortable"
                        color="primary"
                      />
                    </v-col>
                    <v-col cols="12" md="6" lg="3">
                      <v-text-field
                        v-model="model.lastName"
                        :label="resources.LastName"
                        :hint="resources.LastNameHelp"
                        persistent-hint
                        :rules="[globalStore.rules.required]"
                        prepend-inner-icon="mdi-form-textbox"
                        clearable
                        variant="outlined"
                        density="comfortable"
                        color="primary"
                      />
                    </v-col>
                    <v-col cols="12" md="6" lg="3">
                      <v-text-field
                        v-model="model.phone"
                        :label="resources.Phone"
                        :hint="resources.PhoneHelp"
                        persistent-hint
                        :rules="[
                          globalStore.rules.required,
                          globalStore.rules.onlyNumbers,
                        ]"
                        prepend-inner-icon="mdi-phone-outline"
                        clearable
                        variant="outlined"
                        density="comfortable"
                        color="primary"
                      />
                    </v-col>
                    <v-col cols="12" md="6" lg="3">
                      <v-select
                        v-model="model.idDocumentType"
                        :items="viewModel.documentTypes"
                        :label="resources.DocumentType"
                        :hint="resources.DocumentTypeHelp"
                        persistent-hint
                        :rules="[globalStore.rules.required]"
                        prepend-inner-icon="mdi-card-account-details-outline"
                        clearable
                        variant="outlined"
                        density="comfortable"
                        color="primary"
                      />
                    </v-col>
                    <v-col cols="12" md="6" lg="3">
                      <v-text-field
                        v-model="model.documentNumber"
                        :label="resources.DocumentNumber"
                        :hint="resources.DocumentNumberHelp"
                        persistent-hint
                        :rules="[
                          globalStore.rules.required,
                          globalStore.rules.onlyNumbers,
                        ]"
                        prepend-inner-icon="mdi-numeric"
                        clearable
                        variant="outlined"
                        density="comfortable"
                        color="primary"
                      />
                    </v-col>
                    <v-col cols="12" md="6" lg="3">
                      <v-select
                        v-model="model.idGender"
                        :items="viewModel.genders"
                        :label="resources.Gender"
                        :hint="resources.GenderHelp"
                        persistent-hint
                        :rules="[globalStore.rules.required]"
                        prepend-inner-icon="mdi-gender-male-female"
                        clearable
                        variant="outlined"
                        density="comfortable"
                        color="primary"
                      />
                    </v-col>
                    <v-col cols="12" md="6" lg="3">
                      <v-text-field
                        v-model="model.birthDate"
                        :label="resources.BirthDate"
                        :hint="resources.BirthDateHelp"
                        persistent-hint
                        :rules="[globalStore.rules.required]"
                        type="date"
                        clearable
                        variant="outlined"
                        density="comfortable"
                        color="primary"
                      />
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
            </v-card>
          </v-stepper-window-item>

          <v-stepper-window-item :value="2" :editable="stepTwoComplete">
            <v-card variant="text" class="ma-0 pa-0">
              <v-card-title class="text-h5 ma-0 pa-0 text-primary">
                {{ resources.EmergencyData }}
              </v-card-title>
              <v-card-text class="ma-0 pa-0">
                <v-row class="ma-0 pa-0">
                  <v-col cols="12" class="ma-0 pa-0">
                    <p>{{ resources.EmergencyDataDescription }}</p>
                  </v-col>
                </v-row>
                <v-form class="ma-0 pa-0" ref="formStepTwo">
                  <v-row class="ma-0 pa-0">
                    <v-col cols="12" md="6" lg="3">
                      <v-select
                        v-model="model.idBloodFactor"
                        :items="viewModel.bloodFactors"
                        :label="resources.BloodFactor"
                        :hint="resources.BloodFactorHelp"
                        persistent-hint
                        :rules="[globalStore.rules.required]"
                        prepend-inner-icon="mdi-water-outline"
                        clearable
                        variant="outlined"
                        density="comfortable"
                        color="primary"
                      />
                    </v-col>
                    <v-col cols="12" md="6" lg="3">
                      <v-text-field
                        v-model="model.healthInsurance"
                        :label="resources.HealthInsurance"
                        :hint="resources.HealthInsuranceHelp"
                        persistent-hint
                        prepend-inner-icon="mdi-medical-bag"
                        :rules="[globalStore.rules.required]"
                        clearable
                        variant="outlined"
                        density="comfortable"
                        color="primary"
                      />
                    </v-col>
                    <v-col cols="12" md="6" lg="3">
                      <v-text-field
                        v-model="model.emergencyPhone"
                        :label="resources.EmergencyPhone"
                        :hint="resources.EmergencyPhoneHelp"
                        persistent-hint
                        prepend-inner-icon="mdi-phone-outline"
                        :rules="[
                          globalStore.rules.required,
                          globalStore.rules.onlyNumbers,
                        ]"
                        clearable
                        variant="outlined"
                        density="comfortable"
                        color="primary"
                      />
                    </v-col>
                    <v-col cols="12" md="6" lg="3">
                      <v-text-field
                        v-model="model.emergencyName"
                        :label="resources.EmergencyName"
                        :hint="resources.EmergencyNameHelp"
                        persistent-hint
                        prepend-inner-icon="mdi-form-textbox"
                        :rules="[globalStore.rules.required]"
                        clearable
                        variant="outlined"
                        density="comfortable"
                        color="primary"
                      />
                    </v-col>
                  </v-row>
                  <v-row class="ma-0 pa-0" v-if="isMinor">
                    <v-col cols="12" md="6" lg="3">
                      <v-text-field
                        v-model="model.adultName"
                        :label="resources.AdultName"
                        :hint="resources.AdultNameHelp"
                        persistent-hint
                        prepend-inner-icon="mdi-form-textbox"
                        :rules="[globalStore.rules.required]"
                        clearable
                        variant="outlined"
                        density="comfortable"
                        color="primary"
                      />
                    </v-col>
                    <v-col cols="12" md="6" lg="3">
                      <v-text-field
                        v-model="model.adultDocumentNumber"
                        :label="resources.AdultDocumentNumber"
                        :hint="resources.AdultDocumentNumberHelp"
                        persistent-hint
                        prepend-inner-icon="mdi-form-textbox"
                        :rules="[globalStore.rules.required]"
                        clearable
                        variant="outlined"
                        density="comfortable"
                        color="primary"
                      />
                    </v-col>
                    <v-col cols="12" md="6" lg="3">
                      <v-text-field
                        v-model="model.adultEmail"
                        :label="resources.AdultEmail"
                        :hint="resources.AdultEmailHelp"
                        persistent-hint
                        prepend-inner-icon="mdi-email-outline"
                        :rules="[
                          globalStore.rules.required,
                          globalStore.rules.email,
                        ]"
                        clearable
                        variant="outlined"
                        density="comfortable"
                        color="primary"
                      />
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
            </v-card>
          </v-stepper-window-item>

          <v-stepper-window-item :value="3" :editable="stepThreeComplete">
            <v-card variant="text" class="ma-0 pa-0">
              <v-card-title class="text-h5 ma-0 pa-0 text-primary">
                {{ resources.TermsAndConditions }}
              </v-card-title>
              <v-card-text class="ma-0 pa-0">
                <v-row class="ma-0 pa-0">
                  <v-col cols="12" class="ma-0 pa-0">
                    <p>{{ resources.TermsAndConditionsDescription }}</p>
                  </v-col>
                </v-row>
                <v-form class="ma-0 pa-0" ref="formStepThree">
                  <v-row class="ma-0 pa-0">
                    <v-col cols="12">
                      <p>
                        {{ comformityText }}
                      </p>
                    </v-col>
                    <v-col cols="12">
                      <v-checkbox
                        v-model="comform"
                        :rules="[
                          (v) => !!v || resources.TermsAndConditionsValidation,
                        ]"
                        :label="resources.IAgree"
                        color="primary"
                      />
                    </v-col>
                  </v-row>

                  <v-row class="ma-0 pa-0">
                    <v-col cols="12">
                      <p>
                        {{ viewModel.multimediaLabel }}
                      </p>
                    </v-col>
                    <v-col cols="12">
                      <v-checkbox
                        v-model="model.multimedia"
                        :label="resources.IAgree"
                        color="primary"
                      />
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
            </v-card>
          </v-stepper-window-item>
        </v-stepper-window>

        <v-row class="pb-5 mx-5">
          <v-btn
            @click="prevStep"
            :disabled="stepper === 1"
            :loading="globalStore.loading"
            :readonly="globalStore.loading"
          >
            Volver
          </v-btn>

          <v-spacer></v-spacer>

          <v-btn
            color="primary"
            @click="nextStep"
            :loading="globalStore.loading"
            :readonly="globalStore.loading"
          >
            Siguiente
          </v-btn>
        </v-row>
      </v-stepper>
    </v-card-text>
  </v-card>
</template>

<script setup>
import { storeToRefs } from "pinia";
import { ref, computed } from "vue";

const globalStore = window.useGlobalStore();
const form = ref(null);

const stepper = ref(1);

const formStepOne = ref(null);
const stepOneComplete = ref(null);
const formStepOneValid = ref(null);
const stepOneError = ref(null);

const formStepTwo = ref(null);
const stepTwoComplete = ref(null);
const formStepTwoValid = ref(null);
const stepTwoError = ref(null);

const formStepThree = ref(null);
const stepThreeComplete = ref(null);
const formStepThreeValid = ref(null);
const stepThreeError = ref(null);

const prevStep = () => {
  if (stepper.value > 1) stepper.value--;
};

const show = ref(false);
const toggleShow = () => {
  show.value = !show.value;
};

const nextStep = async () => {
  let isValid = false;

  if (stepper.value === 1) {
    const res = await formStepOne.value.validate();
    isValid = res.valid;
    stepOneComplete.value = isValid;
    if (!isValid) stepOneError.value = true;
    else stepOneError.value = false;
  }

  if (stepper.value === 2) {
    const res = await formStepTwo.value?.validate();
    isValid = res.valid;
    stepTwoComplete.value = isValid;
    if (!isValid) stepTwoError.value = true;
    else stepTwoError.value = false;
  }

  if (stepper.value === 3) {
    const res = await formStepThree.value?.validate();
    isValid = res.valid;
    stepThreeComplete.value = isValid;
    if (!isValid) stepThreeError.value = true;
    else {
      stepThreeError.value = false;

      submit();
    }
  }

  window.scrollTo({ top: 0, behavior: "smooth" });

  if (!isValid) {
    return globalStore.showError(resources.value.FormContainsErrors);
  }

  stepper.value++;
};

const { resources } = storeToRefs(globalStore);
const preview = reactive({});
const viewModel = ref({ ...window.VMData });
const comform = ref(false);

const confirmPassword = ref(null);
const isMinor = computed(() => {
  if (!model.value.birthDate) return false;

  const today = new Date();

  const [year, month, day] = model.value.birthDate.split("-");
  const birthDate = new Date(year, month - 1, day);

  let age = today.getFullYear() - birthDate.getFullYear();

  const monthDiff = today.getMonth() - birthDate.getMonth();

  if (
    monthDiff < 0 ||
    (monthDiff === 0 && today.getDate() < birthDate.getDate())
  ) {
    age--;
  }

  return age <= viewModel.value.age;
});
const comformityText = computed(() => {
  return isMinor.value
    ? viewModel.value.conformityMinorLabel
    : viewModel.value.conformityLabel;
});

const submit = async () => {
  globalStore.setLoading(true);
  try {
    const payload = {
      profilePicture: preview["profilePicture"],
      multimedia: model.value.multimedia,
      password: model.value.password,
      idBloodFactor: model.value.idBloodFactor,
      idGender: model.value.idGender,
      idDocumentType: model.value.idDocumentType,
      documentNumber: model.value.documentNumber,
      healthInsurance: model.value.healthInsurance,
      emergencyPhone: model.value.emergencyPhone,
      emergencyName: model.value.emergencyName,
      adultName: model.value.adultName,
      adultDocumentNumber: model.value.adultDocumentNumber,
      adultEmail: model.value.adultEmail,
      email: model.value.email,
      username: model.value.email,
      name: model.value.name,
      lastName: model.value.lastName,
      phone: model.value.phone,
      birthDate: model.value.birthDate,
    };
    const res = await axios.post("/Home/Register", payload);
    const jsonData = res.data;
    if (jsonData.result == 2) {
      window.location.href = jsonData.url;
    } else {
      globalStore.setLoading(false);
      global.errorHandler(jsonData.content);
    }
  } catch (err) {
    global.errorHandler(err);
    globalStore.setLoading(false);
    global.showError(resources.ErrorGeneric);
  }
};

const model = ref({
  profilePicture: null,
  multimedia: false,
  password: null,
  idBloodFactor: null,
  idGender: null,
  idDocumentType: null,
  documentNumber: null,
  healthInsurance: null,
  emergencyPhone: null,
  emergencyName: null,
  adultName: null,
  adultDocumentNumber: null,
  adultEmail: null,
  email: null,
  username: null,
  name: null,
  lastName: null,
  phone: null,
  birthDate: null,
});

async function onImageChange(e, key) {
  let file = null;

  if (Array.isArray(e)) file = e[0];
  else if (e instanceof File) file = e;

  if (!file) {
    model[key] = null;
    preview[key] = null;
    return;
  }

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
    });

  const base64 = await toBase64(file);

  model[key] = base64;
  preview[key] = base64;
}
</script>
